import styles from "./Overlay.module.css";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";
import { useEffect, useState } from "react";
function Overlay({
    top,
    bottom,
    left,
    right,
    translate = {},
    borderRadius = 16,
    shadow = {
        y: 10,
        blur: 24,
        color: "#00123829",
    },
    dropShadow = false,
    maxWidth,
    blur,
    src,
    alt = "",
    mediumResponsive = {},
}) {
    const mediumVars = {
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        translate: translate,
        maxWidth: maxWidth,
        ...mediumResponsive,
    };
    const [ref, isVisible] = useIntersectionObserver(1);
    const [isFadedIn, setFadedIn] = useState(false);

    useEffect(() => {
        if (isVisible && !isFadedIn) {
            setTimeout(() => setFadedIn(true), 600);
        }
    }, [isVisible, isFadedIn]);

    function num(n) {
        return `${n}${isNaN(n) ? "" : "px"}`;
    }

    function formatTranslate(translate) {
        return `${num(translate?.x || "0")} ${num(translate?.y || "0")}`;
    }

    function formatShadow(shadow) {
        return `${num(shadow?.x || 0)} ${num(shadow?.y || 0)} ${num(
            shadow?.blur || 0
        )} ${shadow?.color || "black"}`;
    }

    function formatBoxShadow(boxShadow) {
        return formatShadow(boxShadow);
    }

    function formatDropShadow(dropShadow) {
        return `drop-shadow(${formatShadow(dropShadow)})`;
    }

    function formatBlur(blur) {
        return `blur(${num(blur)})`;
    }

    const styleVars = {
        "--top": num(top),
        "--bottom": num(bottom),
        "--left": num(left),
        "--right": num(right),
        "--translate": formatTranslate(translate),
        "--maxWidth": maxWidth ? num(maxWidth) : "100%",
        "--mediumTop": num(mediumVars.top),
        "--mediumBottom": num(mediumVars.bottom),
        "--mediumLeft": num(mediumVars.left),
        "--mediumRight": num(mediumVars.right),
        "--mediumTranslate": formatTranslate(mediumVars.translate),
        "--mediumMaxWidth": mediumVars.maxWidth
            ? num(mediumVars.maxWidth)
            : "100%",
    };

    const styleObj = {
        borderRadius,
        [dropShadow ? "filter" : "boxShadow"]: dropShadow
            ? formatDropShadow(shadow)
            : formatBoxShadow(shadow),
        backdropFilter: formatBlur(blur),
    };

    function handleMouseMove(event) {
        // ref.current.style.transition =
        // "scale 1s ease, transform 500ms ease-out";

        const rotation = 8;

        const {
            width,
            height,
            x: elX,
            y: elY,
        } = event.target.getBoundingClientRect();
        const x = event.clientX - elX;
        const y = event.clientY - elY;
        const halfWidth = width / 2;
        const halfHeight = height / 2;

        const rotationY = ((halfWidth - x) / halfWidth) * rotation;
        const rotationX = ((y - halfHeight) / halfHeight) * rotation;

        ref.current.style.setProperty(
            "transform",
            `rotateY(${rotationY}deg) rotateX(${rotationX}deg)`
        );
    }

    function handleMouseLeave() {
        ref.current.style.transition = "";

        ref.current.style.setProperty(
            "transform",
            `scale(1) rotateX(0deg) rotateY(0deg)`
        );
    }

    function getAnimationClassName() {
        if (isVisible) {
            if (isFadedIn) {
                return styles.done;
            } else {
                return "zoomFadeIn";
            }
        }
    }

    return (
        <div
            className={styles.overlay_container}
            style={styleVars}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
        >
            <img
                ref={ref}
                style={styleObj}
                src={src}
                alt={alt}
                draggable={false}
                className={[styles.overlay_img, getAnimationClassName()].join(
                    " "
                )}
            />
        </div>
    );
}

export default Overlay;
